<template>
  <v-dialog v-model="add" persistent max-width="370" class="mx-1">
    <v-btn dark color="red lighten-1" small slot="activator">
      <v-icon>add</v-icon> Новый email
    </v-btn>
    <v-card>
      <v-toolbar flat>
        Новый email
        <v-spacer></v-spacer>
        <v-btn flat icon @click.native="add = false; newemail = null">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-text-field
          label="email"
          type="email" autocomplete
          v-model="newemail"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat
          @click.native="add = false; newemail = null"
        >
          Отмена
        </v-btn>
        <v-btn color="primary" flat
          @click.native="addEmailbox"
          :disabled="false === validEmail"
        >
          Продолжить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// eslint-disable-next-line
const emailRe = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
export default {
  name: 'new-email-dialog',
  props: ['profile'],
  data: () => ({
    add: false,
    newemail: null
  }),
  methods: {
    async addEmailbox () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'emailboxes-create-request',
          pl: { email: this.newemail }
        })
        this.$emit('added')
        this.add = false
        this.newemail = null
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  computed: {
    validEmail () {
      return emailRe.test(String(this.newemail).toLowerCase())
    }
  }
}
</script>

<style lang="css">
</style>
